import { motion } from "framer-motion";
import { SectionHeading } from "./SectionHeading";
const items = [{
  e: "📘",
  t: "Biblioteca Clínica de 6 Tomos",
  d: "Un sistema completo que te acompaña desde el diagnóstico inicial hasta la finalización del tratamiento."
}, {
  e: "📋",
  t: "Protocolos Clínicos Paso a Paso",
  d: "Aprende exactamente qué hacer antes, durante y después de cada planificación."
}, {
  e: "🧠",
  t: "Sistema Visual de Decisión Clínica (SVDC)",
  d: "Diagramas, mapas y árboles de decisión para reducir la improvisación y aumentar la predictibilidad."
}, {
  e: "📸",
  t: "Casos Clínicos Ilustrados",
  d: "Ejemplos reales para reconocer patrones y tomar mejores decisiones clínicas."
}, {
  e: "✅",
  t: "Checklists Profesionales",
  d: "Listas de verificación para revisar cualquier planificación antes de aprobarla."
}];
export function Includes() {
  return <section className="w-full bg-slate-50 py-14 sm:py-20" data-id="element-156" data-mp="28tq1px7julpq">
      <div className="mx-auto max-w-lg px-5 sm:max-w-3xl lg:max-w-5xl" data-id="element-157" data-mp="3ufxw60hkjhwq">
        <SectionHeading eyebrow="📦 Qué incluye" title="¿Qué incluye el Sistema Maestro de Planificación con Alineadores?" data-id="element-158" data-mp="3popksywohmgx" />

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-159" data-mp="3lnvxa6n5e9ok">
          {items.map((it, i) => <motion.div key={it.t} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i % 2 * 0.08
        }} className={`flex gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-sm ${i === items.length - 1 ? "sm:col-span-2" : ""}`} data-id="element-160" data-mp="3gpauq0kfbdwy" data-mpi={i}>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#1e88e5]/10 text-2xl" data-id="element-161" data-mp="3bhcj8omfr4q">
                {it.e}
              </span>
              <div data-id="element-162" data-mp="2nxr806ombhq7">
                <h3 className="font-head text-base font-800 text-[#0f2547] sm:text-lg" data-id="element-163" data-mp="2o1f2b81w085z">
                  {it.t}
                </h3>
                <p className="mt-1 text-sm leading-relaxed text-slate-500 sm:text-[15px]" data-id="element-164" data-mp="2ug44ydk8btt9">
                  {it.d}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}